import "./NoBillLealtad.css";

const NoBillLealtad = ({ title, Icon }) => {
  /*Los props van en Titulo y Icono*/
  return (
    <div className="boxnotdatabilllealtad">
      <div>
        <Icon className="iconnotbilllealtad" />
      </div>
      <div className="boxtittlebilllealtad">
        <p className="tittlenotdatabilllealtad">{title}</p>
      </div>
      <div className="boxexplainnotdatabilllealtad">
        <p className="explainotdatabilllealtad">
          Espere al siguiente mes para enviar una factura nueva
        </p>
      </div>
    </div>
  );
};

export default NoBillLealtad;
